// src/utils/testAcc.js
export default function testAcc(value, para, chrIndex, totalChars, totalCorrChars, setAcc) {
    if (value.length > chrIndex) {
      totalChars.current += 1;
      if (value[chrIndex] === para[chrIndex]) {
        totalCorrChars.current += 1;
      }
      setAcc((totalCorrChars.current / totalChars.current) * 100);
    }
  }
  